/**
 * Apple Private Relay アドレス判定（Vue 非依存）。
 */
export function isPrivateRelayEmail(email: string | null | undefined): boolean {
  if (!email) return false
  return email.indexOf('@privaterelay.appleid.com') !== -1
}
